import { render, staticRenderFns } from "./fourthStep.vue?vue&type=template&id=826e26fc&scoped=true"
import script from "./fourthStep.vue?vue&type=script&lang=js"
export * from "./fourthStep.vue?vue&type=script&lang=js"
import style0 from "./fourthStep.vue?vue&type=style&index=0&id=826e26fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e26fc",
  null
  
)

export default component.exports